<template>
  <section class="z-50 menu_bar fixed inset-x-0 bottom-8">
    <div class="flex justify-center items-center">
      <div
        :class="[$root.isDarkMood ? 'menu_bar_bg' : 'dark_menu_bar_bg']"
        class="
          nav_wrapper
          text-center
          w-72
          md:w-80
          flex
          justify-center
          items-center
          space-x-9
          md:space-x-10
          p-3
          rounded-full
        "
      >
        <a
          class="active test home"
          :class="[$root.isDarkMood ? 'icon_color' : 'text-gray-700']"
          href="#home"
        >
          <i class="w-5 h-5 md:w-6 md:h-6 fas fa-home"></i>
        </a>
        <a
          class="test about_me"
          :class="[$root.isDarkMood ? 'icon_color' : 'text-gray-700']"
          href="#about_me"
        >
          <i class="w-5 h-5 md:w-6 md:h-6 fas fa-user-ninja"></i>
        </a>
        <a
          class="test skills"
          :class="[$root.isDarkMood ? 'icon_color' : 'text-gray-700']"
          href="#skills"
        >
          <i class="w-5 h-5 md:w-6 md:h-6 fas fa-laptop-code"></i>
        </a>
        <a
          class="test blogs"
          :class="[$root.isDarkMood ? 'icon_color' : 'text-gray-700']"
          href="#blogs"
        >
          <i class="w-5 h-5 md:w-6 md:h-6 fab fa-readme"></i>
        </a>
        <a
          class="test contactMe"
          :class="[$root.isDarkMood ? 'icon_color' : 'text-gray-700']"
          href="#contactMe"
        >
          <i class="w-5 h-5 md:w-6 md:h-6 fas fa-address-book"></i>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style>
.nav_wrapper a:hover{
  color:  rgb(255, 40, 40);
  transition: hover 12 ease;
}
</style>